import type { FC } from "react";
import { useEffect, useState } from "react";

import { type CampaignOrderData, type CampaignOrderDataItem } from "@jti/rest-api-types";
import { useDispatch, useSelector } from "@jti/store/reduxHooks";
import { fetchLoyaltyVouchers } from "@jti/store/slices/loyaltySlice";

import { useLoyalty } from "@checkout/hooks/useLoyalty";
import { useLoyaltyStatus } from "@checkout/hooks/useLoyaltyStatus";
import getCartItemsCount from "@checkout/utils/getCartItemsCount";

export const CampaignRunner: FC = () => {
  const [campaignOrderData, setCampaignOrderData] = useState<CampaignOrderData>();
  const subtotalIncludingTax = useSelector((state) => state.cart.prices.data?.subtotalIncludingTax.value);
  const items = useSelector((state) => state.cart.items);
  const minimumPayableAmount = useSelector((state) => state.cart.minimumPayableAmount?.value);
  const { loyaltyCampaignId, handleCampaignChange, vouchers } = useLoyalty();
  const dispatch = useDispatch();
  const isLoyaltyActive = useLoyaltyStatus();
  const itemsCount = getCartItemsCount(items);
  const status = useLoyaltyStatus();

  useEffect(() => {
    if (loyaltyCampaignId && status && vouchers.length) {
      const item = vouchers.find(({ campaign_id }) => campaign_id === loyaltyCampaignId);
      if ((item && !item?.is_eligible) || !itemsCount) {
        handleCampaignChange("");
      }
    }
  }, [itemsCount, loyaltyCampaignId, vouchers, status]);

  useEffect(() => {
    if (!subtotalIncludingTax || items.length < 1) return;
    const campaignItems: CampaignOrderDataItem = {};
    items.forEach((item) => {
      const categories = item.categories?.map((category) => category.uid);
      campaignItems[item.sku] = { ...(categories && { categories }), price: item.price.value, qty: item.quantity };
    });
    const data: CampaignOrderData = {
      ...(minimumPayableAmount ? { minimumPayableAmount } : {}),
      items: campaignItems,
      orderTotal: subtotalIncludingTax,
    };
    setCampaignOrderData(data);
  }, [minimumPayableAmount, items.length, subtotalIncludingTax]);

  useEffect(() => {
    if (isLoyaltyActive && campaignOrderData) {
      dispatch(fetchLoyaltyVouchers(campaignOrderData));
    }
  }, [dispatch, isLoyaltyActive, campaignOrderData]);

  return <></>;
};
